/**
 * @Description Fasat Filter Setting Page
 * @FileName index.js
 * @Author Abhisek Kundu - kundabh
 * @CreatedOn 24 May, 2021 21:40:00
 * @IssueID - 436
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import './index.scss';
import {
  animateFilterComponent, configSelColumn, configureCustFilCrt, CREATE, custFilList, formatFilterCriteriaParams,
  formatOrder, getCancelModal, getDuplicateModal, getFilterInstance, getListRequest,
  initialAccordionState, ModalDuplicateSelection, selectedFilIn, setDropdownItem, SHAREDFILTER,
  SYSDEFAULT, UPDATE, validateIsSharedFlag, configureGroupByColumn, setFilterType, bridgeFilterMethod,
  configureSortColumn, scrollListBoxToTopPosition, formatParamsSearch,
  stringBlankModal, operatorBtwnValidate,
} from './filterUtil';
import { staticCommonLabelKeys as cmnLblKey } from '../../moduleConstants';
import { FasatChip, FasatModal } from '..';
import { getAction } from '../../../../stateManagement/reduxUtil';
import {
  checkDirtyData, getCustomFilterList, getDeafultFilterSettings, getOperatorList,
  getRolesList, resetUpsertValue, setRoleList, updateUseOnFilter,
} from '../../redux/actions/commonActions';
import SaveFilter from './saveFilter/saveFilter';
import { getCurrentLocale } from '../../i18n';
import { formatColumnOrderForUI, initialReqObject, resetUpsertValue as resetUpsertVal, scrollToTop } from '../../util';
import FilterPanel from './filterPanel';
import { defaultProps, propTypes } from './filterProps';

/**
 * class names, id names, for names, width(s) defined
 */
const filterSettingsPanelClass = 'filterSettingsPanel';
const panelHeaderTextClass = 'panelHeaderText';
const sysDefaultFilterHeaderClass = 'sysDefaultFilterHeader';
const modalWidth = '560px';
const UPDATE_USAGE = 'UPDATE_USAGE';
const sumRecordCount = 'sumRecordCount';
const sortFilterList = () => [{ key: 'defaultFilter', asc: false }];
export const checkFilterIsDefault = (filterData) => !filterData.isSystemFilter && filterData.isDefault;
export const validateClone = (cloneFilter) => cloneFilter?.detail?.columnOrders?.length > 0;
export const validateUserDefault = (filterLoadCount, filterData) => !filterLoadCount && filterData.isDefault && !filterData.isSystemFilter;
export const validateSystemDefault = (filterLoadCount, filterData) => !filterLoadCount && filterData.isDefault && filterData.isSystemFilter;
const isActionUpdate = (action) => (action === UPDATE);
export const setPreUserDefault = ({ currentFilterObject, loggedInUser }) => (currentFilterObject && (currentFilterObject.owner === loggedInUser && (!currentFilterObject.isSystemFilter && currentFilterObject.isDefault)));
export const setLoggedInUser = (loggedUser) => (loggedUser?.UserId);
export const extractID = (action, currentFilterObject) => (currentFilterObject && action === UPDATE ? currentFilterObject.id : '');
export const extractName = (action, currentFilterObject) => (currentFilterObject && action === UPDATE ? currentFilterObject.name : '');
export const extractDesc = (action, currentFilterObject) => (currentFilterObject && action === UPDATE ? currentFilterObject.description : '');
export const isCrtFilterDefOne = (currentFilterObject, action) => (currentFilterObject && isActionUpdate(action));
/**
       * Functionality on click of Search button
       */
const optionArray = ['OPT_BETWEEN', 'OPT_NOT_BETWEEN'];
export const searchFunc = ({ columnOrder, custFilCreteria, displayWarningMessage,
  setValidateFilterCriteria, triggerSearch, setDisplayWarningMessage, setDisplayBetWarningMsg,
  displayBetWarningMsg }) => {
  if (columnOrder.length > 0) {
    if (custFilCreteria.length > 0) {
      const filterValidate = operatorBtwnValidate(custFilCreteria);
      if (filterValidate.find((idx) => optionArray.includes(idx.operator)) !== undefined) {
        setDisplayBetWarningMsg(!displayBetWarningMsg);
      } else {
        triggerSearch();
        setValidateFilterCriteria(0);
      }
    } else {
      triggerSearch();
      setValidateFilterCriteria(0);
    }
  } else {
    setDisplayWarningMessage(!displayWarningMessage);
  }
};
/**
        * This is to configure the Pre selected unsaved Filter Criteria
        */
export const configFil = ({ listColumnOrder, setSelectedColumn, listGroupBy, setSelectedGroupByOption,
  listSortOptions, setSelectedSortOptions, setSelectedParametOptions, listParamOptions, isDistinctActive,
  setIsDistinct, setGroupByActive }) => {
  if (listColumnOrder) {
    setSelectedColumn(listColumnOrder);
  } else {
    setSelectedColumn([]);
  }
  if (listGroupBy && listGroupBy.length > 0) {
    setSelectedGroupByOption(listGroupBy);
    setGroupByActive(true);
  } else {
    setSelectedGroupByOption([]);
    setGroupByActive(false);
  }
  if (listSortOptions) {
    setSelectedSortOptions(listSortOptions);
  } else {
    setSelectedSortOptions(null);
  }
  if (listParamOptions) {
    setSelectedParametOptions(listParamOptions);
  } else {
    setSelectedParametOptions([]);
  }
  setIsDistinct(isDistinctActive);
};
const setSelColumn = (columnOrders) => columnOrders || [];
const setSortOpts = (sortOptions) => sortOptions || null;
/**
     * This is to configure the Pre selected Filter Criteria
     */
export const selectedFilFun = ({ filterData, setSelectedColumn, setSelectedGroupByOption,
  setSelectedSortOptions, setSelectedParametOptions, setGroupByActive, setIsDistinct }) => {
  if (filterData.detail) {
    setIsDistinct(filterData.detail.isDistinct);
    setSelectedColumn(setSelColumn(filterData.detail.columnOrders));
    if (filterData.detail.groupByParameters) {
      setSelectedGroupByOption(filterData.detail.groupByParameters);
      if (filterData.detail.groupByParameters.length > 0) {
        setGroupByActive(true);
      }
    }
    setSelectedSortOptions(setSortOpts(filterData.detail.sortOptions));

    if (filterData.detail.parameters) {
      setSelectedParametOptions(filterData.detail.parameters);
    } else {
      setSelectedParametOptions([]);
    }
  }
};
const filterDataFuc = ({ filterData, setDeselectColumnOrder, validateAndConfigureFilter, setCurrentFilterObject,
  filterLoadCount, setUsrDfltFltID, setFltLoadCnt, setIsSysDefaultFilter, configureDefaultFilter,
  setSelectedFilterType }) => {
  if (filterData) {
    setDeselectColumnOrder(false);
    const filterInstance = bridgeFilterMethod(filterData);
    setCurrentFilterObject(filterInstance);
    if (validateUserDefault(filterLoadCount, filterData)) {
      setUsrDfltFltID(filterData.id);
      setFltLoadCnt(1);
      setIsSysDefaultFilter(false);
    }
    const isSysDef = validateSystemDefault(filterLoadCount, filterData);
    if (isSysDef) {
      setIsSysDefaultFilter(true);
    }
    if (filterData.isDefault) {
      configureDefaultFilter(filterData);
    }
    if (!filterData.isDefault && !filterData.isSystemFilter) {
      setSelectedFilterType(SHAREDFILTER);
    }
    if (filterData.detail.groupByParameters === null) {
      const updatefilterdata = filterData;
      updatefilterdata.detail.groupByParameters = filterData.detail.groupByParameters || [];
      validateAndConfigureFilter(updatefilterdata, isSysDef);
    } else {
      validateAndConfigureFilter(filterData, isSysDef);
    }
  }
};
export const fasatChipFunc = ({ currentFilterObject, t, userDefaultFilterID, loggedInUser }) => {
  const tag = [];
  if (currentFilterObject) {
    if (userDefaultFilterID === currentFilterObject.id
      && currentFilterObject.owner === loggedInUser) {
      tag.push(t(cmnLblKey.FILTER_LABEL_MY_DEFAULT));
    }
    if (currentFilterObject.isShared) {
      tag.push(t(cmnLblKey.COMMON_LABEL_SHARED));
    }
    if (currentFilterObject.owner === loggedInUser && !currentFilterObject.isShared) {
      tag.push(t(cmnLblKey.FILTER_LABEL_PRIVATE));
    }
  }
  return (
    <>
      {tag.length > 0
        && (
          <div className="chipSection">
            {tag.map((item) => (
              <FasatChip
                data={item}
                hasCloseBtn={false}
                isDefaultChip={item === t(cmnLblKey.FILTER_LABEL_MY_DEFAULT)}
                key={item}
              />
            ))}
          </div>
        )}
    </>
  );
};
export const filterDescFunc = ({ t, currentFilterObject, label, createNewFilterFlag }) => {
  let filterTitle;
  if (currentFilterObject?.isSystemFilter) {
    if (label === 'title') {
      filterTitle = createNewFilterFlag ? t(cmnLblKey.FILTER_LABEL_NEW) : t(cmnLblKey.FILTER_LABEL_SYSTEM_DEFAULT);
    } else {
      filterTitle = t(cmnLblKey.FILTER_LABEL_HELP);
    }
  }
  if (currentFilterObject && !currentFilterObject.isSystemFilter) {
    if (label === 'title') {
      filterTitle = currentFilterObject.name;
    } else {
      filterTitle = currentFilterObject.description;
    }
  }
  return filterTitle;
};
export const filterCriteriaFunc = ({ custFilCreteria, setCustFilCreteria, value }) => {
  if (value && value.key !== '') {
    const cloneCustomCreteria = custFilCreteria;
    const foundIndex = custFilCreteria.findIndex((x) => x.uuid === value.uuid);
    if (foundIndex >= 0) {
      cloneCustomCreteria[foundIndex] = value;
      setCustFilCreteria(cloneCustomCreteria);
    } else {
      setCustFilCreteria([...cloneCustomCreteria, value]);
    }
  }
};

const loadSaveModal = ({ formData, isSystemDefaultFilter, userDefaultFilterID, entityId, updateDefaultFilterID,
  entityFilterConfig, screenName, renderCustFilListCnt, sharedFilterCount, resetNewFilFlg }) => (
    <SaveFilter
      formData={formData}
      onSaveTopic="ADD_FILTER_SAVE"
      entityId={entityId}
      isSystemDefaultFilter={isSystemDefaultFilter}
      userDefaultFilterID={userDefaultFilterID}
      updateDefaultFilterID={updateDefaultFilterID}
      onCancelTopic="ADD_FILTER_CANCEL"
      updateFilterAction={entityFilterConfig.UPDATE_FILTER_CONFIG}
      screenName={screenName}
      sharedFilterCount={sharedFilterCount}
      renderFilterList={renderCustFilListCnt}
      resetNewFilterFlag={resetNewFilFlg}
      entityFilterConfig={entityFilterConfig}
    />
);
const loadAptFilter = ({ deletedFilterID, currentFilterObject, loadSelectedFilter, setUsrDfltFltID, dispatch,
  userDefaultFilterID, systemDefaultFilter, entityFilterConfig, userDefaultFilter }) => {
  if (deletedFilterID === currentFilterObject.id) {
    if (currentFilterObject.id === userDefaultFilterID) {
      loadSelectedFilter(systemDefaultFilter, true);
      setUsrDfltFltID(null);
      dispatch(getAction(entityFilterConfig.REMOVE_USER_DEFAULT_FILTER));
    } else {
      loadSelectedFilter(userDefaultFilter, true);
    }
  }
};
const configureFormData = ({ dispatch, action, currentFilterObject, customColumnGroupBy,
  customColumnSorting, loggedInUser, displayModal, isDistinct,
  setSaveNewFilter, custFilCreteria, columnOrder, entityId, setFormData, setDisplayModal }) => {
  dispatch(resetUpsertValue(resetUpsertVal));
  const configFormData = {
    action,
    customColumnGroupBy,
    isDistinct,
    customColumnSorting,
    custFilCreteria,
    columnOrder,
    entityId,
    id: extractID(action, currentFilterObject),
    name: extractName(action, currentFilterObject),
    description: extractDesc(action, currentFilterObject),
    isShared: validateIsSharedFlag({ action, currentFilterObject }),
    sharedWith: (currentFilterObject && action === UPDATE)
      && currentFilterObject.sharedWith ? currentFilterObject.sharedWith.join() : '',
    owner: loggedInUser,
    isDefault: (isCrtFilterDefOne(currentFilterObject, action)
      ? (currentFilterObject.owner === loggedInUser
        && (!currentFilterObject.isSystemFilter && currentFilterObject.isDefault)) : false),
    preUserDefaultFilter: (setPreUserDefault({
      currentFilterObject,
      loggedInUser,
    }) ? currentFilterObject.name : false),
  };
  setFormData(configFormData);
  setSaveNewFilter(action === CREATE);
  setDisplayModal(!displayModal);
};
const getColumnOrderBasedOnGrpBy = ({ isGroupByActive, groupByColumnOrder, columnOrder,
  systemDefaultFilter, isColumnOrderChange }) => {
  if (!isGroupByActive && !isColumnOrderChange) {
    return systemDefaultFilter.detail.columnOrders;
  }
  return isGroupByActive ? groupByColumnOrder : columnOrder;
};

const formatAndDispatchSearch = ({ dispatch, customColumnSorting, customColumnGroupBy, custFilCreteria, columnOrder,
  locale, paramForFreezeColumn, currentFilterObject, customPageSize, entityFilterConfig, formatFilterObject,
  createNewFilterFlag, listActive, groupByActive, systemDefaultFilter, isColumnOrderChange, isDistinct,
  isExtSrceen }) => {
  const sortedColOredr = customColumnSorting.map(({ key, asc }) => ({ key, asc }));
  const grpByColumnValues = customColumnGroupBy.map(({ key, operator }) => (
    { key, operator }));
  const formatedParameterObject = formatFilterCriteriaParams(custFilCreteria);
  const formatedParamObjSrch = formatParamsSearch(custFilCreteria);
  let paramObjSrch = null;
  const groupByColumnOrder = [];
  const isGroupByActive = groupByActive && grpByColumnValues.length > 0;
  if (paramForFreezeColumn) {
    paramObjSrch = [...paramForFreezeColumn, ...formatedParamObjSrch];
  } else {
    paramObjSrch = formatedParamObjSrch;
  }
  if (isGroupByActive) {
    grpByColumnValues.map((item) => groupByColumnOrder.push(item.key));
    groupByColumnOrder.push(sumRecordCount); // add additional column for sum of record count
  }
  // filter column order if group by selected
  const selectColumnOrder = getColumnOrderBasedOnGrpBy({
    isGroupByActive,
    groupByColumnOrder,
    columnOrder,
    systemDefaultFilter,
    isColumnOrderChange,
  });
  const filterDetails = {
    parameters: paramObjSrch,
    groupByParameters: grpByColumnValues,
    sortOptions: sortedColOredr,
    columnOrder: selectColumnOrder,
    groupByActive,
    isDistinct,
    isExtSrceen,
  };
  const filterInstance = getFilterInstance(
    currentFilterObject,
    formatedParameterObject,
    customColumnSorting,
    selectColumnOrder,
    grpByColumnValues,
    isDistinct,
  );
  const exportType = 'NONE';
  const reqListObject = getListRequest({ customPageSize, filterDetails, locale, exportType, listActive });
  dispatch(getAction(entityFilterConfig.SEARCH_ACTION, reqListObject));
  dispatch(getAction(entityFilterConfig.UPDATE_TABLE_CONFIGURATION, filterInstance));
  // Scroll the main content container to top after search to keep results in view
  scrollToTop();
  if (!createNewFilterFlag) {
    formatFilterObject(currentFilterObject);
  }
};
const operateLoadFilter = ({ setCreateNewFilterFlag, modalCLose, setshowCustFilModal, showCustFilModal, dispatch,
  filterData, userDefaultFilter, entityFilterConfig, setIsSysDefaultFilter }) => {
  setCreateNewFilterFlag(false);
  if (!modalCLose) {
    setshowCustFilModal(!showCustFilModal);
  }
  const cloneFilter = filterData;
  if (validateClone(cloneFilter) && typeof cloneFilter.detail.columnOrders[0] !== 'string') {
    const configureCOlumnOrder = formatColumnOrderForUI(cloneFilter.detail.columnOrders);
    cloneFilter.detail.columnOrders = configureCOlumnOrder;
  }
  const userDefault = userDefaultFilter;
  dispatch(getAction(
    entityFilterConfig.UPDATE_FILTER_CONFIG,
    { selectedItem: cloneFilter, userDefault },
  ));
  setIsSysDefaultFilter(false);
};
const configureStoreFilObj = ({ entityFilterConfig, filterData, dispatch, loggedInUser }) => {
  const { preUserDefaultFilter } = filterData && (filterData.owner === loggedInUser
    && (checkFilterIsDefault(filterData)))
    ? filterData.name : false;
  const setParam = formatParamsSearch(filterData.detail?.parameters);
  const formatObject = {
    action: UPDATE_USAGE,
    filter: {
      id: filterData.id,
      owner: filterData.owner,
      entityId: filterData.entityId,
      name: filterData.name,
      description: filterData.description,
      isDefault: filterData.isDefault || false,
      isShared: filterData.isShared || false,
      isSystemFilter: false,
      sharedWith: filterData.sharedWith || [],
      detail: {
        parameters: setParam,
        groupByParameters: filterData.detail?.groupByParameters,
        isDistinct: filterData.detail?.isDistinct,
        sortOptions: filterData.detail?.sortOptions,
        columnOrders: filterData.detail && formatOrder(filterData.detail.columnOrders),
      },
    },
  };
  const requestPayload = {
    formatObject,
    preUserDefaultFilter,
    setAction: entityFilterConfig.UPDATE_FILTER_CONFIG,
  };
  dispatch(updateUseOnFilter(requestPayload));
};
const setCustomColumnState = ({ selectedSortOptions, setCustomColumnSorting }) => {
  if (selectedSortOptions) {
    const custSelSortOption = selectedSortOptions.map(({ key, asc }) => ({
      key,
      asc,
      uuid: uuidv4(),
    }));
    setCustomColumnSorting(custSelSortOption);
  } else {
    setCustomColumnSorting([]);
  }
};
const setCustomGroupbyState = ({ selectedGroupByOption, setCustomColumnGroupBy, setGroupByActive }) => {
  if (selectedGroupByOption) {
    const selectedGroupByColumn = selectedGroupByOption.map(({ key, operator }) => ({
      key,
      operator,
      uuid: uuidv4(),
    }));
    setCustomColumnGroupBy(selectedGroupByColumn);
  } else {
    setCustomColumnGroupBy(null);
  }
  if (selectedGroupByOption && selectedGroupByOption.length === 0) {
    setGroupByActive(false);
  }
};
const resetFilterOnEntityUpdate = ({ loadPreSelectedFilterConfig, entityFilterConfig, entityId, dispatch,
  renderCustFilListCnt, loggedInUser }) => {
  if (entityFilterConfig.UPDATE_FILTER_CONFIG && loadPreSelectedFilterConfig === false) {
    const requestPayload = {
      entityId: { entityId },
      setAction: entityFilterConfig.UPDATE_FILTER_CONFIG,
      loggedInUser,
    };
    dispatch(getDeafultFilterSettings(requestPayload));
  }
  renderCustFilListCnt();
};
const renderFilterPanel = ({ t, loadPreSelectedFilterConfig, resetPreSelectedFilterConfig, headFilObj,
  createNewFilter, userDefaultFilter, search, selectedFilterType, loadDropdown, lookupData,
  availableColumns, filCriteriaObj, freezeColumn, custFilCreteria, validateFilterCriteria,
  sortedColumn, groupByColumn, removeSortedColumn, removeGroupByColumn, customColumnSorting,
  customColumnGroupBy, setCustomColumnGroupBy, columnOrderChange, currentFilterObject,
  showDuplicateMessage, selectedColumn, deselectColumnOrder, loggedInUser, openSaveFilterModal,
  groupByActive, setGroupByActive, setCustomColumnSorting, setIsColumnOrderChange, entityFilterConfig, isDistinct, setIsDistinct,
  filterPanelExpanded, setFilterPanelExpanded }) => (
    <FilterPanel
      t={t}
      loadPreSelectedFilterConfig={loadPreSelectedFilterConfig}
      resetPreSelectedFilterConfig={resetPreSelectedFilterConfig}
      headFilObj={headFilObj}
      createNewFilter={createNewFilter}
      userDefaultFilter={userDefaultFilter}
      search={search}
      selectedFilterType={selectedFilterType}
      loadDropdown={loadDropdown}
      lookupData={lookupData}
      availableColumns={availableColumns}
      filCriteriaObj={filCriteriaObj}
      freezeColumn={freezeColumn}
      custFilCreteria={custFilCreteria}
      validateFilterCriteria={validateFilterCriteria}
      sortedColumn={sortedColumn}
      groupByColumn={groupByColumn}
      removeSortedColumn={removeSortedColumn}
      removeGroupByColumn={removeGroupByColumn}
      customColumnSorting={customColumnSorting}
      customColumnGroupBy={customColumnGroupBy}
      setCustomColumnGroupBy={setCustomColumnGroupBy}
      columnOrderChange={columnOrderChange}
      currentFilterObject={currentFilterObject}
      showDuplicateMessage={showDuplicateMessage}
      selectedColumn={selectedColumn}
      deselectColumnOrder={deselectColumnOrder}
      loggedInUser={loggedInUser}
      openSaveFilterModal={openSaveFilterModal}
      groupByActive={groupByActive}
      setGroupByActive={setGroupByActive}
      setCustomColumnSorting={setCustomColumnSorting}
      setIsColumnOrderChange={setIsColumnOrderChange}
      entityFilterConfig={entityFilterConfig}
      isDistinct={isDistinct}
      setIsDistinct={setIsDistinct}
      filterPanelExpanded={filterPanelExpanded}
      setFilterPanelExpanded={setFilterPanelExpanded}
    />
);
// #region useEffectHelper for reducing number of lines in function
const useEffectHelper = ({ loadPreSelectedFilterConfig, entityFilterConfig, entityId, loggedInUser, dispatch, renderCustFilListCnt,
  operatorList, gridData, activateDataGrid, selectedSortOptions, setCustomColumnSorting, selectedGroupByOption,
  setCustomColumnGroupBy, setGroupByActive, setColumnOrder, selectedColumn1, isColumnOrderChange, setSelectedColumn,
  systemDefaultFilter, selectedParametOptions, setCustFilCreteria, createNewCustomFilter, createNewFilter, defaultNewCustomFilter,
  setDeselectColumnOrder, setFilterData, selectedFilter, sharedFilterCount, setFilterPanelExpanded, _filterPanelExpanded }) => {
  useEffect(() => {
    const renderObj = { loadPreSelectedFilterConfig, entityFilterConfig, entityId, loggedInUser };
    resetFilterOnEntityUpdate({ ...renderObj, dispatch, renderCustFilListCnt });
  }, [entityId]);
  useEffect(() => {
    if (operatorList === null) {
      dispatch(getOperatorList());
    }
  }, [operatorList]);
  useEffect(() => {
    animateFilterComponent(gridData, activateDataGrid, setFilterPanelExpanded);
  }, [gridData, activateDataGrid]);
  useEffect(() => {
    dispatch(setRoleList(null));
    dispatch(getRolesList());
  }, [operatorList]);
  useEffect(() => {
    setCustomColumnState({ selectedSortOptions, setCustomColumnSorting });
  }, [selectedSortOptions]);
  useEffect(() => {
    setCustomGroupbyState({
      selectedGroupByOption,
      setCustomColumnGroupBy,
      setGroupByActive,
    });
  }, [selectedGroupByOption]);
  useEffect(() => {
    setColumnOrder(selectedColumn1);
  }, [selectedColumn1]);
  useEffect(() => {
    configSelColumn({
      isColumnOrderChange,
      setSelectedColumn,
      systemDefaultFilter,
    });
  }, [isColumnOrderChange]);
  /**
   * format custom Parameter options as per selected Filter
   */
  useEffect(() => {
    configureCustFilCrt({ selectedParametOptions, setCustFilCreteria });
  }, [selectedParametOptions]);
  useEffect(() => {
    if (createNewCustomFilter) {
      createNewFilter(defaultNewCustomFilter);
    } else {
      selectedFilIn({ setDeselectColumnOrder, setFilterData, selectedFilter, systemDefaultFilter, sharedFilterCount });
    }
  }, [selectedFilter, sharedFilterCount]);
};
// #endregion
const useCustomState = () => {
  const [columnOrder, setColumnOrder] = useState([]);
  const [isColumnOrderChange, setIsColumnOrderChange] = useState(true);
  const [selectedFilterType, setSelectedFilterType] = useState(SYSDEFAULT);
  const [customColumnSorting, setCustomColumnSorting] = useState([]);
  const [customColumnGroupBy, setCustomColumnGroupBy] = useState([]);
  const [isDistinct, setIsDistinct] = useState(false);
  const [filterPanelExpanded, setFilterPanelExpanded] = useState(true);
  const [displayModal, setDisplayModal] = useState(false);
  const [groupByActive, setGroupByActive] = useState(false);
  const [validateFilterCriteria, setValidateFilterCriteria] = useState(0);
  const [showCustFilModal, setShowCustFilModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [isSystemDefaultFilter, setIsSystemDefaultFilter] = useState(true);
  const [usrDfltFltID, setUsrDfltFltID] = useState(null);
  const [fltLoadCnt, setFltLoadCnt] = useState(0);
  const [selectedSortOptions, setSelectedSortOptions] = useState(null);
  const [selectedGroupByOption, setSelectedGroupByOption] = useState([]);
  const [selectedParametOptions, setSelectedParametOptions] = useState(null);
  const [selectedColumn1, setSelectedColumn1] = useState([]);
  const [currentFilterObject, setCurrentFilterObject] = useState(null);
  const [saveNewFilter, setSaveNewFilter] = useState(true);
  const [deselectColumnOrder, setDeselectColumnOrder] = useState(false);
  const [createNewFilterFlag, setCreateNewFilterFlag] = useState(false);
  const [custFilCreteria, setCustFilCreteria] = useState([]);
  const [displayDuplicateSel, setDisplayDuplicateSel] = useState(false);
  const [displayWarningMessage, setDisplayWarningMessage] = useState(false);
  const [displayBetWarningMsg, setDisplayBetWarningMsg] = useState(false);
  const [cancelDisplayModal, setCancelDisplayModal] = useState(false);
  return {
    columnOrder,
    setColumnOrder,
    isColumnOrderChange,
    setIsColumnOrderChange,
    selectedFilterType,
    setSelectedFilterType,
    customColumnSorting,
    setCustomColumnSorting,
    customColumnGroupBy,
    setCustomColumnGroupBy,
    isDistinct,
    setIsDistinct,
    filterPanelExpanded,
    setFilterPanelExpanded,
    displayModal,
    setDisplayModal,
    groupByActive,
    setGroupByActive,
    validateFilterCriteria,
    setValidateFilterCriteria,
    showCustFilModal,
    setShowCustFilModal,
    formData,
    setFormData,
    isSystemDefaultFilter,
    setIsSystemDefaultFilter,
    usrDfltFltID,
    setUsrDfltFltID,
    fltLoadCnt,
    setFltLoadCnt,
    selectedSortOptions,
    setSelectedSortOptions,
    selectedGroupByOption,
    setSelectedGroupByOption,
    selectedColumn1,
    setSelectedColumn1,
    currentFilterObject,
    setCurrentFilterObject,
    saveNewFilter,
    setSaveNewFilter,
    deselectColumnOrder,
    setDeselectColumnOrder,
    createNewFilterFlag,
    setCreateNewFilterFlag,
    custFilCreteria,
    setCustFilCreteria,
    displayDuplicateSel,
    setDisplayDuplicateSel,
    displayWarningMessage,
    setDisplayWarningMessage,
    displayBetWarningMsg,
    setDisplayBetWarningMsg,
    cancelDisplayModal,
    setCancelDisplayModal,
    selectedParametOptions,
    setSelectedParametOptions,
  };
};

const useCustomSelector = (entityFilterConfig) => {
  const operatorList = useSelector((state) => state.ApplicationStateFilterList.operatorList);
  const sharedFilterCount = useSelector((state) => state.ApplicationStateFilterList.filterListCount);
  const selectedFilter = useSelector((state) => state[entityFilterConfig.REDUX_STATE].selectedFilter);
  const systemDefaultFilter = useSelector((state) => state[entityFilterConfig.REDUX_STATE].systemDefaultFilter);
  const userDefaultFilter = useSelector((state) => state[entityFilterConfig.REDUX_STATE].userDefaultFilter);
  const listSortOptions = useSelector((state) => state[entityFilterConfig.REDUX_STATE].listSortOptions);
  const listGroupBy = useSelector((state) => state[entityFilterConfig.REDUX_STATE].listGroupBy);
  const isDistinctActive = useSelector((state) => state[entityFilterConfig.REDUX_STATE].isDistinctActive);
  const listParamOptions = useSelector((state) => state[entityFilterConfig.REDUX_STATE].listParamOptions);
  const listColumnOrder = useSelector((state) => state[entityFilterConfig.REDUX_STATE].listColumnOrder);
  const loggedUser = useSelector(({ ApplicationStateRBAC }) => ApplicationStateRBAC.loggedUser);
  const gridData = useSelector((state) => state[entityFilterConfig.REDUX_STATE].listData);
  return {
    operatorList,
    sharedFilterCount,
    selectedFilter,
    systemDefaultFilter,
    userDefaultFilter,
    gridData,
    listSortOptions,
    listGroupBy,
    isDistinctActive,
    listParamOptions,
    listColumnOrder,
    loggedUser,
  };
};

// #region Handler FUnctions
const colOrderChangeHandler = (setColumnOrder, selectedOption, setIsColumnOrderChange) => {
  setColumnOrder(selectedOption);
  setIsColumnOrderChange(true);
};

const createNewFilterHandler = ({ setDeselectColumnOrder, setCurrentFilterObject, entityId, availableColumns,
  setSelectedColumn, setSelectedSortOptions, systemDefaultFilter,
  setSelectedParametOptions, defaultOptions, setSelectedGroupByOption,
  setIsSystemDefaultFilter, setCreateNewFilterFlag }) => {
  setDeselectColumnOrder(true);
  scrollListBoxToTopPosition();
  setCurrentFilterObject({ entityId });
  const columns = [];
  availableColumns.map(({ value }) => columns.push(value));
  setSelectedColumn(columns);
  setSelectedSortOptions(systemDefaultFilter?.detail?.sortOptions);
  setSelectedParametOptions(defaultOptions ? defaultOptions.parameters : null);
  setSelectedGroupByOption([]);
  setIsSystemDefaultFilter(false);
  initialAccordionState();
  setCreateNewFilterFlag(true);
};

const rmvSortedColHandler = (customColumnSorting, value, setCustomColumnSorting) => {
  const filterOutColumn = customColumnSorting.filter((x) => x.uuid !== value.uuid);
  setCustomColumnSorting(filterOutColumn);
};

const rmvGrpByColHandler = (customColumnGroupBy, value, setCustomColumnGroupBy) => {
  const filterOutColumn = customColumnGroupBy.filter((x) => x.uuid !== value.uuid);
  setCustomColumnGroupBy(filterOutColumn);
};

const updateDefaultFilterHandler = (setUsrDfltFltID, filID, setFltLoadCnt, setIsSystemDefaultFilter) => {
  setUsrDfltFltID(filID);
  setFltLoadCnt(1);
  setIsSystemDefaultFilter(false);
};

const cacelClickHandler = (setCancelDisplayModal, cancelDisplayModal) => {
  setCancelDisplayModal(!cancelDisplayModal);
  if (document.getElementsByClassName('saveFilterModal')) {
    document.querySelector('.saveFilterModal').parentElement.style.zIndex = '99996';
  }
};

const discardClickHandler = (dispatch, setDisplayModal, displayModal) => {
  dispatch(checkDirtyData(false));
  setDisplayModal(!displayModal);
};
const handleColumnSelection = (cols, availableColumns, setSelectedColumn1) => {
  // Created refrence before filtering the available fields to maintain the impact of call by reference
  const selectedColsArr = cols;
  const availableSelectedColumn = cols.filter((colum) => availableColumns.findIndex((availCol) => availCol.value === colum) >= 0);
  selectedColsArr.length = 0;
  selectedColsArr.push(...availableSelectedColumn);
  setSelectedColumn1(selectedColsArr);
};

const openSaveFilterHandler = ({ custFilCreteria, setDisplayBetWarningMsg, displayBetWarningMsg,
  setValidateFilterCriteria, saveObjA, saveObjB }) => {
  let saveTrigger = true;
  if (custFilCreteria) {
    const filterValidate = operatorBtwnValidate(custFilCreteria);
    if (filterValidate.find((idx) => optionArray.includes(idx.operator)) !== undefined) {
      setDisplayBetWarningMsg(!displayBetWarningMsg);
      saveTrigger = false;
    } else {
      setValidateFilterCriteria(0);
    }
  }
  if (saveTrigger) {
    configureFormData({ ...saveObjA, ...saveObjB });
  }
};

const filterSettingFunctionUtility = ({ setSelectedParametOptions, listParamOptions, loadPreSelectedFilterConfig,
  setSelectedColumn, setSelectedGroupByOption, setSelectedSortOptions, setGroupByActive,
  setIsDistinct, listColumnOrder, listGroupBy, isDistinctActive, listSortOptions, setSelectedFilterType,
  setDeselectColumnOrder, setCurrentFilterObject, setUsrDfltFltID, fltLoadCnt, setFltLoadCnt,
  setIsSystemDefaultFilter, setColumnOrder, setIsColumnOrderChange, customColumnSorting,
  setCustomColumnSorting, customColumnGroupBy, setCustomColumnGroupBy, custFilCreteria, setCustFilCreteria,
  dispatch, reqObjFilter, entityFilterConfig, loggedInUser, setCreateNewCustomFilter, setCreateNewFilterFlag,
  showCustFilModal, setShowCustFilModal, userDefaultFilter, triggerActivateDataGrid, freezeColumn, columnOrder,
  createNewFilterFlag, systemDefaultFilter, isColumnOrderChange, locale, currentFilterObject, customPageSize,
  paramForFreezeColumn, listActive, groupByActive, isDistinct, isExtSrceen, displayWarningMessage,
  setValidateFilterCriteria, setDisplayWarningMessage, validateFilterCriteria, setDisplayBetWarningMsg,
  displayBetWarningMsg, onSearchClick, entityId, availableColumns, displayModal, setSaveNewFilter, setFormData, setDisplayModal }) => {
  const validateAndConfigureFilter = (filterData, isSYSDefault) => {
    const configParamas = { setSelectedParametOptions, listParamOptions };
    if (!loadPreSelectedFilterConfig) {
      selectedFilFun({ filterData, setSelectedColumn, setSelectedGroupByOption, setSelectedSortOptions, setSelectedParametOptions, setGroupByActive, setIsDistinct, isSYSDefault, ...configParamas });
    } else {
      configFil({ listColumnOrder, setSelectedColumn, listGroupBy, setSelectedGroupByOption, isDistinctActive, setIsDistinct, listSortOptions, setSelectedSortOptions, setGroupByActive, ...configParamas });
    }
  };
  const configureDefaultFilter = (filterData) => setFilterType({ filterData, setSelectedFilterType });
  const setFilterData = (filterData, isSYSDefault) => {
    const setFilObjA = { filterData, setDeselectColumnOrder, setCurrentFilterObject, setUsrDfltFltID, filterLoadCount: fltLoadCnt };
    const setFilObjB = { configureDefaultFilter, setSelectedFilterType, validateAndConfigureFilter, isSYSDefault };
    filterDataFuc({ ...setFilObjA, ...setFilObjB, setFltLoadCnt, setIsSysDefaultFilter: setIsSystemDefaultFilter });
  };
  const columnOrderChange = (selectedOption) => { colOrderChangeHandler(setColumnOrder, selectedOption, setIsColumnOrderChange); };
  const sortedColumn = (value) => configureSortColumn({ value, customColumnSorting, setCustomColumnSorting });
  const groupByColumn = (value) => configureGroupByColumn({ value, customColumnGroupBy, setCustomColumnGroupBy });
  const setfiterCriteria = (value) => filterCriteriaFunc({ custFilCreteria, setCustFilCreteria, value });
  const renderCustFilListCnt = () => dispatch(getCustomFilterList({ reqObjFilter, listCount: true }));
  const formatFilterObject = (filterData) => { configureStoreFilObj({ entityFilterConfig, filterData, dispatch, loggedInUser }); };
  const removeSortedColumn = (value) => { rmvSortedColHandler(customColumnSorting, value, setCustomColumnSorting); };
  const removeGroupByColumn = (value) => { rmvGrpByColHandler(customColumnGroupBy, value, setCustomColumnGroupBy); };
  const loadSelectedFilter = (filterData, modalCLose) => {
    setCreateNewCustomFilter(false);
    const loadFilObjA = { setCreateNewFilterFlag, modalCLose, showCustFilModal, dispatch, setshowCustFilModal: setShowCustFilModal };
    operateLoadFilter({ ...loadFilObjA, filterData, userDefaultFilter, entityFilterConfig, setIsSysDefaultFilter: setIsSystemDefaultFilter });
  };
  const triggerSearch = () => {
    triggerActivateDataGrid();
    const formatObjA = { dispatch, custFilCreteria, freezeColumn, columnOrder, createNewFilterFlag, systemDefaultFilter, isColumnOrderChange };
    const formatObjB = { locale, currentFilterObject, customPageSize, entityFilterConfig, formatFilterObject };
    formatAndDispatchSearch({ ...formatObjA, ...formatObjB, customColumnSorting, customColumnGroupBy, paramForFreezeColumn, listActive, groupByActive, isDistinct, isExtSrceen });
  };
  const search = () => {
    const searchParams = { displayWarningMessage, setValidateFilterCriteria, triggerSearch, setDisplayWarningMessage };
    searchFunc({ columnOrder, custFilCreteria, validateFilterCriteria, ...searchParams, setDisplayBetWarningMsg, displayBetWarningMsg });
    onSearchClick();
  };
  const createNewFilter = (defaultOptions = null) => {
    const newFilterArgs = {
      setDeselectColumnOrder,
      setCurrentFilterObject,
      entityId,
      availableColumns,
      setSelectedColumn,
      setSelectedSortOptions,
      systemDefaultFilter,
      setSelectedParametOptions,
      defaultOptions,
      setSelectedGroupByOption,
      setIsSystemDefaultFilter,
      setCreateNewFilterFlag,
    };
    createNewFilterHandler(newFilterArgs);
  };
  const openSaveFilterModal = (action) => {
    const saveObjA = { dispatch, action, customColumnGroupBy, isDistinct, customColumnSorting, loggedInUser, displayModal, setSaveNewFilter };
    const saveObjB = { custFilCreteria, columnOrder, entityId, setFormData, currentFilterObject, setDisplayModal };
    openSaveFilterHandler({ custFilCreteria, setDisplayBetWarningMsg, displayBetWarningMsg, setValidateFilterCriteria, saveObjA, saveObjB });
  };
  const loadDropdown = (val) => {
    const dDObjA = { setCreateNewFilterFlag, showCustFilModal, setDeselectColumnOrder, setshowCustFilModal: setShowCustFilModal };
    const dDObjB = { val, userDefaultFilter, setFilterData, systemDefaultFilter };
    setDropdownItem({ ...dDObjA, ...dDObjB });
    initialAccordionState();
    scrollListBoxToTopPosition();
  };
  const removeFilCriElmt = (value) => {
    const filterOutElement = custFilCreteria.filter((x) => x.uuid !== value);
    setCustFilCreteria(filterOutElement);
  };
  return { loadSelectedFilter, renderCustFilListCnt, createNewFilter, setFilterData, setfiterCriteria, removeFilCriElmt, search, loadDropdown, sortedColumn, groupByColumn, removeSortedColumn, removeGroupByColumn, columnOrderChange, openSaveFilterModal };
};

// #endregion

function FasatFilterSetting({ availableColumns, entityId, customPageSize, lookupData, entityFilterConfig,
  triggerActivateDataGrid, screenName, loadPreSelectedFilterConfig, freezeColumn, paramForFreezeColumn,
  resetPreSelectedFilterConfig, listActive, activateDataGrid, defaultNewCustomFilter, onSearchClick, isExtSrceen,
  filterPanelExpanded: filterPanelExpandedProp, setFilterPanelExpanded: setFilterPanelExpandedProp }) {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const locale = getCurrentLocale();
  const parameters = [{ key: 'entityId', operator: 'OPT_EQUALS', type: 'number', values: [entityId] }];
  const {
    columnOrder, setColumnOrder, isColumnOrderChange, setIsColumnOrderChange, selectedFilterType, setSelectedFilterType, customColumnSorting, setCustomColumnSorting,
    customColumnGroupBy, setCustomColumnGroupBy, isDistinct, setIsDistinct, filterPanelExpanded: filterPanelExpandedState, setFilterPanelExpanded: setFilterPanelExpandedState, displayModal, setDisplayModal, groupByActive, setGroupByActive,
    validateFilterCriteria, setValidateFilterCriteria, showCustFilModal, setShowCustFilModal, formData, setFormData, isSystemDefaultFilter, setIsSystemDefaultFilter,
    usrDfltFltID, setUsrDfltFltID, fltLoadCnt, setFltLoadCnt, selectedSortOptions, setSelectedSortOptions, selectedGroupByOption, setSelectedGroupByOption,
    selectedColumn1, setSelectedColumn1, currentFilterObject, setCurrentFilterObject, saveNewFilter, setSaveNewFilter, deselectColumnOrder, setDeselectColumnOrder,
    createNewFilterFlag, setCreateNewFilterFlag, custFilCreteria, setCustFilCreteria, displayDuplicateSel, setDisplayDuplicateSel, displayWarningMessage, setDisplayWarningMessage,
    displayBetWarningMsg, setDisplayBetWarningMsg, cancelDisplayModal, setCancelDisplayModal, selectedParametOptions, setSelectedParametOptions,
  } = useCustomState();
  const {
    operatorList, sharedFilterCount, selectedFilter, systemDefaultFilter, userDefaultFilter, gridData,
    listSortOptions, listGroupBy, isDistinctActive, listParamOptions, listColumnOrder, loggedUser,
  } = useCustomSelector(entityFilterConfig);
  // Use prop values if provided, otherwise use internal state
  const filterPanelExpanded = filterPanelExpandedProp !== undefined ? filterPanelExpandedProp : filterPanelExpandedState;
  const setFilterPanelExpanded = setFilterPanelExpandedProp || setFilterPanelExpandedState;
  const setSelectedColumn = (cols) => { handleColumnSelection(cols, availableColumns, setSelectedColumn1); };
  const reqObjFilter = initialReqObject({ locale, sortFilterList, parameters });
  const [createNewCustomFilter, setCreateNewCustomFilter] = useState(!!defaultNewCustomFilter);
  const loggedInUser = setLoggedInUser(loggedUser);
  const { loadSelectedFilter, renderCustFilListCnt, createNewFilter, setFilterData, setfiterCriteria, removeFilCriElmt, search,
    loadDropdown, sortedColumn, groupByColumn, removeSortedColumn, removeGroupByColumn, columnOrderChange, openSaveFilterModal } = filterSettingFunctionUtility({
    setSelectedParametOptions,
    listParamOptions,
    loadPreSelectedFilterConfig,
    setSelectedColumn,
    setSelectedGroupByOption,
    setSelectedSortOptions,
    setGroupByActive,
    setIsDistinct,
    listColumnOrder,
    listGroupBy,
    isDistinctActive,
    listSortOptions,
    setSelectedFilterType,
    setDeselectColumnOrder,
    setCurrentFilterObject,
    setUsrDfltFltID,
    fltLoadCnt,
    setFltLoadCnt,
    setIsSystemDefaultFilter,
    setColumnOrder,
    setIsColumnOrderChange,
    customColumnSorting,
    setCustomColumnSorting,
    customColumnGroupBy,
    setCustomColumnGroupBy,
    custFilCreteria,
    setCustFilCreteria,
    dispatch,
    reqObjFilter,
    entityFilterConfig,
    loggedInUser,
    setCreateNewCustomFilter,
    setCreateNewFilterFlag,
    showCustFilModal,
    setShowCustFilModal,
    userDefaultFilter,
    triggerActivateDataGrid,
    freezeColumn,
    columnOrder,
    createNewFilterFlag,
    systemDefaultFilter,
    isColumnOrderChange,
    locale,
    currentFilterObject,
    customPageSize,
    paramForFreezeColumn,
    listActive,
    groupByActive,
    isDistinct,
    isExtSrceen,
    displayWarningMessage,
    setValidateFilterCriteria,
    setDisplayWarningMessage,
    validateFilterCriteria,
    setDisplayBetWarningMsg,
    displayBetWarningMsg,
    onSearchClick,
    entityId,
    availableColumns,
    displayModal,
    setSaveNewFilter,
    setFormData,
    setDisplayModal,
  });
  const showDuplicateMessage = () => setDisplayDuplicateSel(!displayDuplicateSel);
  const updateDefaultFilterID = (filID) => { updateDefaultFilterHandler(setUsrDfltFltID, filID, setFltLoadCnt, setIsSystemDefaultFilter); };
  const filterTag = () => fasatChipFunc({ currentFilterObject, t, loggedInUser, userDefaultFilterID: usrDfltFltID });
  const getFilterTitleDesc = (label) => filterDescFunc({ t, currentFilterObject, label, createNewFilterFlag });
  const triggerFilterListCount = (deletedFilterID) => {
    const paramsObjA = { deletedFilterID, currentFilterObject, loadSelectedFilter, setUsrDfltFltID, dispatch };
    const paramsObjB = { userDefaultFilterID: usrDfltFltID, systemDefaultFilter, entityFilterConfig, userDefaultFilter };
    loadAptFilter({ ...paramsObjA, ...paramsObjB });
    renderCustFilListCnt();
  };
  const onCancelClickCancel = useCallback(() => { cacelClickHandler(setCancelDisplayModal, cancelDisplayModal); }, [cancelDisplayModal]);
  const onClickDiscard = () => { discardClickHandler(dispatch, setDisplayModal, displayModal); };
  // #region Use effects
  useEffectHelper({
    loadPreSelectedFilterConfig,
    entityFilterConfig,
    entityId,
    loggedInUser,
    dispatch,
    renderCustFilListCnt,
    operatorList,
    gridData,
    activateDataGrid,
    selectedSortOptions,
    setCustomColumnSorting,
    selectedGroupByOption,
    setCustomColumnGroupBy,
    setGroupByActive,
    setColumnOrder,
    selectedColumn1,
    isColumnOrderChange,
    setSelectedColumn,
    systemDefaultFilter,
    selectedParametOptions,
    setCustFilCreteria,
    createNewCustomFilter,
    createNewFilter,
    defaultNewCustomFilter,
    setDeselectColumnOrder,
    setFilterData,
    selectedFilter,
    sharedFilterCount,
    setFilterPanelExpanded,
    filterPanelExpanded,
  });
  // #endregion
  const resetNewFilFlg = () => setCreateNewFilterFlag(false);
  const saveFilObjA = { isSystemDefaultFilter, renderCustFilListCnt, resetNewFilFlg, userDefaultFilterID: usrDfltFltID };
  const saveFilObjB = { formData, entityFilterConfig, screenName, entityId, sharedFilterCount, updateDefaultFilterID };
  const headFilObj = { t, getFilterTitleDesc, filterTag, createNewFilterFlag, sharedFilterCount, currentFilterObject };
  const filCriteriaObj = { setfiterCriteria, removeFilCriElmt, showDuplicateMessage, availableColumns, operatorList };
  const filterPanelParams = {
    t,
    loadPreSelectedFilterConfig,
    resetPreSelectedFilterConfig,
    headFilObj,
    createNewFilter,
    userDefaultFilter,
    search,
    selectedFilterType,
    loadDropdown,
    lookupData,
    availableColumns,
    filCriteriaObj,
    freezeColumn,
    custFilCreteria,
    validateFilterCriteria,
    sortedColumn,
    groupByColumn,
    removeSortedColumn,
    removeGroupByColumn,
    customColumnSorting,
    customColumnGroupBy,
    setCustomColumnGroupBy,
    columnOrderChange,
    showDuplicateMessage,
    deselectColumnOrder,
    loggedInUser,
    currentFilterObject,
    openSaveFilterModal,
    groupByActive,
    setGroupByActive,
    setCustomColumnSorting,
    setIsColumnOrderChange,
    entityFilterConfig,
    isDistinct,
    setIsDistinct,
    filterPanelExpanded,
    setFilterPanelExpanded,
    selectedColumn: selectedColumn1,
  };
  return (
    <div className={filterSettingsPanelClass}>
      {renderFilterPanel(filterPanelParams)}
      <FasatModal
        title={saveNewFilter ? t(cmnLblKey.FILTER_LABEL_SAVE_AS) : t(cmnLblKey.FILTER_LABEL_SAVE)}
        display={displayModal}
        modalWidth={modalWidth}
        primaryButtonText={t(cmnLblKey.COMMON_BUTTON_SAVE)}
        primaryTopic="ADD_FILTER_SAVE"
        secondaryButtonText={t(cmnLblKey.COMMON_BUTTON_CANCEL)}
        secondaryTopic="ADD_FILTER_CANCEL"
        openModal="OPEN_ADD_FILTER_MODAL"
        modalClass="saveFilterModal"
        onModalClose={useCallback(() => { setDisplayModal(false); }, [])}
        isCheckDirty="yes"
        onCancelClickCancel={onCancelClickCancel}
      >
        {formData && (loadSaveModal({ ...saveFilObjA, ...saveFilObjB }))}
        {getCancelModal({ cancelDisplayModal, onCancelClickCancel, onClickDiscard, t })}
      </FasatModal>
      {custFilList({ t, showCustFilModal, loadSelectedFilter, triggerFilterListCount, entityId, setshowCustFilModal: setShowCustFilModal, handleLoadSelectedFilter: (filterData) => loadSelectedFilter(filterData) })}
      {ModalDuplicateSelection({ handleModalDisplay: () => setDisplayDuplicateSel(false), duplicateSelection: t(cmnLblKey.FILTER_DUPLICATE_COL_SELECTED_MSG).split('.'), displayDuplicateSel, setDisplayDuplicateSel, t })}
      {getDuplicateModal({ t, setDisplayWarningMessage, displayWarningMessage, duplicateModalMessage: () => setDisplayWarningMessage(false) })}
      {stringBlankModal({ t, setDisplayBetWarningMsg, displayBetWarningMsg, handleModalClosedWarningMsg: () => setDisplayBetWarningMsg(false) })}
    </div>
  );
}
FasatFilterSetting.propTypes = propTypes;
FasatFilterSetting.defaultProps = defaultProps;
export default FasatFilterSetting;
